module.exports = __webpack_public_path__ + "media/speech-bubbles/square-speech-bubble--foot-left--desktop-d82f3be6.svg";